import { apiClient } from "./apiClient"; // adjust path as needed
import { COLOR_MEDIA_URL } from "./endpoints"; // You'll define this constant

type ColorMediaParams = {
  slug: string;
  colorId: string;
  mediaTypes: "IMAGE";
  tagNames: string;
};

export type ColorMediaItem = {
  fileName: string;
  fileType: string;
  s3Url: string;
  colorId: number;
  altTag: string | null;
  metadata: {
    thumbnail: string | null;
    title: string | null;
    primaryText: string | null;
    duration: string | null;
    secondaryText: string | null;
    authorName: string | null;
    authorType: string | null;
  };
  createdAt: string;
  updatedAt: string;
  tagNames: string[] | null;
  locked: boolean;
  standOut: boolean;
};

export type ColorMediaResponse = {
  mediaGroups: {
    IMAGE?: {
      totalCount: number;
      media: ColorMediaItem[];
    };
  };
};

export const colorMediaService = {
  getColorMedia: async (params: ColorMediaParams) => {
    const response = await apiClient.get(COLOR_MEDIA_URL, params, {
      withAuth: false,
    });

    return (response as ColorMediaResponse)?.mediaGroups?.IMAGE?.media || [];
  },
};
